import { MandatoryAccountModal } from 'components/MandatoryAccountModal/MandatoryAccountModal';
import { Nothing } from 'components/Nothing/Nothing';
import { useMandatoryAccountEligibility } from 'hooks/useMandatoryAccountEligibility/useMandatoryAccountEligibility';
import { useSelector } from 'react-redux';
import { isUserCreated } from 'selectors';

const MandatoryAccount = () => {
  const userCreated = useSelector(isUserCreated);
  const showSignupTab = !userCreated;

  const { eligibility, testVariants } = useMandatoryAccountEligibility();

  const activeModal =
    (eligibility.india && testVariants.india === 'C') ||
    (eligibility.china && testVariants.china === 'C');

  return activeModal ? (
    <MandatoryAccountModal showSignupTab={showSignupTab} />
  ) : (
    <Nothing />
  );
};

export { MandatoryAccount };
